import { render, staticRenderFns } from "./TransfersDetails.vue?vue&type=template&id=07c8f290&scoped=true&"
import script from "./TransfersDetails.vue?vue&type=script&lang=js&"
export * from "./TransfersDetails.vue?vue&type=script&lang=js&"
import style0 from "./TransfersDetails.vue?vue&type=style&index=0&id=07c8f290&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c8f290",
  null
  
)

export default component.exports